"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorCodeTranslationKeys = void 0;
var _types = require("../../types");
const errorCodeTranslationKeys = exports.errorCodeTranslationKeys = {
  // default fallback, equal to 500
  0: {
    headline: _types.ErrorPageTranslationKey.headline,
    text: _types.ErrorPageTranslationKey.text,
    contactSupportTeam: _types.ErrorPageTranslationKey.contactSupportTeam,
    buttonText: _types.ErrorPageTranslationKey.buttonText
  },
  // Custom error code, reserved for WAF blocked pages
  1: {
    headline: _types.ErrorPageTranslationKey.headline,
    text: _types.ErrorPageTranslationKey.rejectedUrl,
    contactSupportTeam: _types.ErrorPageTranslationKey.contactSupportTeam,
    buttonText: _types.ErrorPageTranslationKey.buttonText
  },
  401: {
    headline: _types.ErrorPageTranslationKey.headline,
    text: _types.ErrorPageTranslationKey.unauthorized,
    contactSupportTeam: _types.ErrorPageTranslationKey.contactSupportTeam,
    buttonText: _types.ErrorPageTranslationKey.buttonText
  },
  404: {
    headline: _types.ErrorPageTranslationKey.headline,
    text: _types.ErrorPageTranslationKey.notFound,
    contactSupportTeam: _types.ErrorPageTranslationKey.contactSupportTeam,
    buttonText: _types.ErrorPageTranslationKey.buttonText
  },
  500: {
    headline: _types.ErrorPageTranslationKey.headline,
    text: _types.ErrorPageTranslationKey.text,
    contactSupportTeam: _types.ErrorPageTranslationKey.contactSupportTeam,
    buttonText: _types.ErrorPageTranslationKey.buttonText
  }
};
